import { MultiPolygon, Polygon } from 'geojson'
import { EditCoverageArea } from '~/components/editCoverageArea'
import healthTeamFetchDefinition from '../fetch/healthTeamFetch.definition'
import healthTeamSmartMappingDefinition, {
  recommendedSmartMappingOptions,
} from '../smartMapping/healthTeamSmartMapping.definition'
import healthTeamEditCoverageAreaDefinition from './healthTeamEditCoverageArea.definition'

interface HealthTeam {
  key: string
  ine: string
  healthUnitCnes: string
  name: string
  latitude: number
  longitude: number
  coverageArea: Polygon | MultiPolygon | null
  kind:
    | 'smartMapping'
    | 'deprecated'
    | 'manualDrawing'
    | 'authorityProvided'
    | 'openStreetMapSourced'
    | null
}

const EditCoverageAreaScreen = EditCoverageArea<
  HealthTeam,
  typeof healthTeamFetchDefinition.input,
  typeof healthTeamFetchDefinition.output,
  typeof healthTeamEditCoverageAreaDefinition.input,
  typeof healthTeamEditCoverageAreaDefinition.output,
  typeof healthTeamSmartMappingDefinition.input,
  typeof healthTeamSmartMappingDefinition.output
>

export default function HealthTeamEditCoverageAreaScreen() {
  return (
    <EditCoverageAreaScreen
      editCoverageAreaDefinition={healthTeamEditCoverageAreaDefinition}
      fetchDefinition={healthTeamFetchDefinition}
      smartMappingDefinition={healthTeamSmartMappingDefinition}
      recommendedSmartMappingOptions={recommendedSmartMappingOptions}
      getSmartMappingBlockReason={delimitation => {
        if (!delimitation) {
          return 'Selecione uma unidade de saúde para executar o mapeamento inteligente'
        }

        if (!delimitation.key) {
          return 'Mapeamento inteligente de equipes exige delimitação por unidade de saúde'
        }

        return null
      }}
    />
  )
}
